var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64285 0H2.35715C1.73199 0 1.13245 0.252806 0.690397 0.702804C0.248347 1.1528 6.19372e-06 1.76313 6.19372e-06 2.39952V15.197C-0.000543466 15.3379 0.0355005 15.4765 0.104489 15.5987C0.173477 15.7209 0.27296 15.8224 0.392863 15.8928C0.512306 15.963 0.647798 16 0.78572 16C0.923641 16 1.05913 15.963 1.17858 15.8928L5.5 13.3493L9.82142 15.8928C9.94117 15.9619 10.0766 15.9978 10.2143 15.9968C10.3519 15.9978 10.4874 15.9619 10.6071 15.8928C10.727 15.8224 10.8265 15.7209 10.8955 15.5987C10.9645 15.4765 11.0005 15.3379 11 15.197V2.39952C11 1.76313 10.7517 1.1528 10.3096 0.702804C9.86755 0.252806 9.26801 0 8.64285 0ZM9.42857 13.8133L5.89286 11.7337C5.77341 11.6635 5.63792 11.6265 5.5 11.6265C5.36208 11.6265 5.22659 11.6635 5.10714 11.7337L1.57143 13.8133V2.39952C1.57143 2.18739 1.65421 1.98395 1.80156 1.83395C1.94891 1.68395 2.14876 1.59968 2.35715 1.59968H8.64285C8.85124 1.59968 9.05109 1.68395 9.19844 1.83395C9.34579 1.98395 9.42857 2.18739 9.42857 2.39952V13.8133Z",
    fill: "#167092"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/tags.799da19b233d9c4ddcd2c91a3496131a.svg";
export { ForwardRef as ReactComponent };